//import enLocale from 'element-plus/dist/locale/en.mjs'
import enLocale from 'element-plus/dist/locale/en'

// en.js
export default {
  ...enLocale, // Element Plus 英文包
  message: {
    // en.js
    login: {
      title: 'Digi SFT Login',
      username: 'Username',
      password: 'Password',
      loginBtn: 'Login',
      rememberChek: 'Remember username',
      client:"Customer Platform",
      server:"Management Platform",
      usernameRequired: 'Please enter username',
      passwordRequired: 'Please enter password',
      success: 'Login successful',
      failed: 'Login failed, please check username and password',
      fillAllFields: 'Please fill in all required fields',
      httpError: 'HTTP error! Status:',
      invalidResponse: 'Invalid response format'
    },
    request:{
      tokenExpired:"The session has expired, please log in again",
    },
    system: {
      title: 'Digi SFT'
    },
    rtu: {
      title: 'RTU status',
      tabStatus: 'Status',
      tabSetpoints: 'Setpoints',
      lastUpdated: 'Last updated',
      live: 'live',
      refresh: 'Refresh',
      refreshing: 'Refreshing…',
      refreshed: 'Refresh requested — updating from the device',
      refreshFailed: 'Refresh failed',
      stale: 'stale',
      staleData: 'Data is stale (last update {time}). Please refresh.',
      alarmBanner: '{n} active alarm(s)',
      checkFdd: 'Check FDD',
      liveSection: 'Live status',
      updatesEvery: 'updates every 5 s',
      roomTemp: 'Room temp',
      oat: 'OAT',
      sat: 'SAT',
      fanSpeed: 'Fan speed',
      compSpeed: 'Compressor',
      damper: 'Damper',
      power: 'Power',
      indoorFanChip: 'Indoor fan',
      y1: 'Compressor Y1',
      y2: 'Compressor Y2',
      w1: 'Heater W1',
      w2: 'Heater W2',
      occupiedChip: 'Occupied',
      on: 'ON',
      off: 'OFF',
      healthSection: 'Health (FDD)',
      healthHint: 'green = normal · red = alarm · gray = no data',
      comfortGroup: 'Energy & comfort',
      statusGroup: 'Status & alarms',
      alarmTag: 'ALARM',
      ind: {
        energy: 'Energy', demand: 'Demand', cooling: 'Cooling', heating: 'Heating',
        iaq: 'IAQ', humidity: 'Humidity',
        economizer: 'Economizer', indoorFan: 'Indoor fan / coil',
        outdoorFan: 'Outdoor fan / coil', compressor: 'Compressor', heaters: 'Heaters',
        vfd: 'VFD', sensors: 'Sensors'
      },
      schedSection: 'Occupancy schedule',
      schedHint: 'applies to this unit',
      day: 'Day',
      occupiedFrom: 'Occupied from',
      occupiedUntil: 'Occupied until',
      smartRecovery: 'Smart recovery',
      days: { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' },
      modified: 'modified',
      holidays: 'Holidays',
      openSlots: '{n} open slots',
      unoccupiedAllDay: 'unoccupied',
      changesPending: '{n} change(s) pending',
      writesOnlyChanged: 'writes only the changed days',
      noChanges: 'No pending changes',
      discard: 'Discard',
      reviewApply: 'Review & apply',
      reviewTitle: 'Apply schedule changes?',
      reviewBody: 'The following days will be written to the unit:',
      applyConfirm: 'Apply',
      cancel: 'Cancel',
      schedApplied: 'Schedule written and confirmed',
      schedBothTimes: '{day}: set both start and end times, or clear both',
      schedStartBeforeEnd: '{day}: start time must be before end time',
      historySection: 'History',
      historyHint: 'setpoint vs. actual · run states · faults',
      range24h: '24 h',
      range7d: '7 d',
      range30d: '30 d',
      seriesSetpoint: 'Setpoint',
      seriesRoom: 'Room temp',
      faultEvent: 'Fault event',
      runStates: 'Run states',
      lanes: { fan: 'Fan', compressor: 'Compressor', heat: 'Heat', occupied: 'Occupied' },
      spHint: 'writes to the unit, then confirms by read-back',
      occHeat: 'Occupied heat',
      occCool: 'Occupied cool',
      unoccHeat: 'Unoccupied heat',
      unoccCool: 'Unoccupied cool',
      fanMode: 'Fan',
      auto: 'Auto',
      occupiedOpt: 'Occupied',
      unoccOpt: 'Unoccupied',
      fanOnOpt: 'On',
      apply: 'Apply changes',
      applying: 'Writing…',
      applied: 'Confirmed by read-back',
      spApplied: 'Setpoints written and confirmed',
      writePending: 'Written — waiting for the unit to report the new values (this can take a few minutes on a real gateway)',
      writeConfirming: 'Written — confirming with the unit…',
      spConfirmed: 'Setpoints confirmed by the unit',
      confirmingNote: 'Confirming with the unit…',
      writeUnmapped: 'Not written — these registers are not configured on this unit. Check the template variable mapping: {vars}',
      noSpData: 'This unit has not reported any setpoint values — its variable mapping may be incomplete',
      schedMappingIncomplete: 'Some schedule registers are not configured on this unit — those cells are disabled. Check the template variable mapping.',
      spStagedNote: 'Changes are staged — nothing is written until Apply. After writing, the unit\'s value is read back and shown here.',
      writeFailed: 'Write failed',
      deadbandError: 'Heat and cool setpoints must be at least {n}°F apart',
      deadbandNote: 'Heat and cool setpoints keep a minimum {n}°F separation — values that cross it are blocked before anything is written to the unit.',
      modeNow: 'Mode',
      activeSetpoint: 'Active setpoint',
      loadFailed: 'Failed to load device data',
      opMode: 'Operating mode',
      // OMC enum (2C V4 firmware, confirmed by Changlin 2026-07-17)
      modes: {
        0: 'Unknown', 1: 'Fire lockout', 2: 'Off', 3: 'Ventilation',
        4: 'Heating', 5: 'Cooling'
      },
      series: { sp: 'Setpoint', room: 'Room temp', oat: 'OAT', sat: 'SAT' },
      exportCsv: 'Export CSV',
      fleetTitle: 'RTU dashboard',
      fleetName: 'RTU',
      fleetCompressor: 'Compressor',
      fleetHeater: 'Heater',
      fleetNoData: 'No data reported',
      stage1: 'Stage 1',
      stage2: 'Stage 2',
      groupMember: 'Group {g}.',
      groupPropagates: 'Temperature setpoints entered here are the group base — each unit receives base + its offset:',
      groupSelf: 'this unit',
      groupApplied: 'Also updated {n} grouped RTU(s)',
      groupEditTitle: 'RTU groups',
      groupEditHint: 'RTUs in the same group share temperature setpoints for staging. When a setpoint changes on one, each other member is set to that value plus its offset (°F). Group 0 = ungrouped.',
      groupCol: 'Group',
      offsetCol: 'Offset °F',
      groupLocalNote: 'Saved in this browser (overrides the shared default). Ask an admin to bake changes into the shared config for all users.',
      groupReset: 'Reset to shared default',
      groupSaved: 'Group assignments saved (this browser)',
      groupResetDone: 'Reset to shared default',
      groupLabel: 'Group {g}',
      ungroupedLabel: 'Ungrouped',
      groupCount: '{n} RTU(s)',
      effTip: 'Value this unit actually receives (group base + its offset)',
      fleetSetpoints: 'Setpoints H/C',
      spOcc: 'occ',
      spUnocc: 'unocc',
      fleetSetpointsTip: 'Actual heat/cool setpoints this unit holds for its current occupancy period (grouped units show their staged values)'
    },
    menu: {
      navigation: 'Navigation',
      dashboard: 'Dashboard',
      system: 'System management',
      company: 'Organization management',
      user: 'User management',
      role: 'Role management',
      operationLog: 'Operator log',
      settings: 'System settings',
      device: 'Device management',
      deviceList: 'Device list',
      deviceTemplate: 'Device template',
      gateway: 'Device gateway',
      dataCenter: 'Data center',
      realtimeData: 'Realtime data',
      realtimePlot: 'Realtime plot',
      history: 'Historical records',
      alarms: 'Alarm records',      
      clientDevice: 'Project',
      message:"Message",
      account:"Account",
      project:"Project management",
      projectList:"Project list",
    },
    common: {
      langChanged: 'Language changed',
      langChangeFailed: 'Failed to change language',
      profileDeveloping: 'Profile is under development',
      logoutConfirm: 'Are you sure you want to log out?',
      tip: 'Tip',
      confirm: 'Confirm',
      cancel: 'Cancel',
      noToken: 'No token',
      httpError: 'HTTP error',
      logoutSuccess: 'Logout successful',    
      logoutFailed: 'Logout failed',
      logoutCancelled: 'Logout cancelled',      
      logoutError:'Logout error',
      warning:'warning',
      saveSuccess: "Save Success",
      saveFailed: "Save Failed",
      deleteSuccess: 'Delete success',
      deleteFailed: 'Delete failed',
      deleteCancelled: 'Delete cancelled',
      updateSuccess: 'Update success',
      addSuccess: 'Add success',
      submitError: "Submit Error",
      fetchError: "Failed to fetch data",
      error:'Error',
      edit:"Edit",
      delete:"Delete",
      search:"Search",      
      total: "Total {total} items",
      goto:"Goto",
      page:"Page",
      reset:"reset",
      noData:"No data",
      loading:"Loading",
      loadFailed:"Load failed",
      exit:"return to main page",      
        success:"success",    
        failed:"failed",        
        info:"info",
        save:"save",
        gridView:"gridView",
        listView:"listView"
    },
    dashboardMsg: {
      welcomingSpeech:"Welcome to BesTech",
      currentTime: "Current time",
      dashboardName: "Dashboard",
      locale:"en-US",
    },
     "underConstruction": {
      "title": "Under Construction",
      "description": "This page is currently under construction. Please check back later."
    },
    "organization": {
        "title": "Organization Management",
        "add": "Add Organization",
        "edit": "Edit Organization",
        "structure": "Organization Structure",
        "namePlaceholder": "Enter organization name",        
        "addMessage": "Add organization function",
        "editMessage": "Edit organization: {name}",
        "deleteConfirm": "Confirm to delete organization \"{name}\"?",
        "editNodeMessage": "Edit node: {label}",
        "deleteNodeConfirm": "Confirm to delete node \"{label}\"?",
        "company":"Organization",
          "inputName":"Please enter the organization name",
          "parentCompany":"Superior organization",
          "selectCompany":"Please select an organization",           
          "inputDescribe":"Please enter an organization description of no more than 50 characters",     
          "id":"Id",
          "name": "Name",        
        "parent": "Parent Organization",
        "describe": "Description",
        "createdAt": "Created At",
        "actions": "Actions",
          "contact":"Contact",          
          "phone":"Phone",          
          "location":"Location",          
          "inputContact":"Please enter the contact person",          
          "inputPhone":"Please enter phone number",          
          "inputLocation":"Please enter the address",          
          "nameRequired":"Please enter the organization name",         
            "companyRequired":"Please select the parent organization",         
            "noData":"No data",    
                  "deleteSuccess": 'Delete success',
      "deleteFailed": 'Delete failed, please unbind first',
      "deleteCancelled": 'Delete cancelled',
      "updateSuccess": 'Update success',
      "updateFailed": 'Update failed',
      "addSuccess": 'Add success',
      "addFailed": 'Addition failed, there are duplicates or other reasons. Please check the data',      
      "operationFailed":"Operation failed",
      "rootCompany":"Root organization",
      },
    "users": {
      "title": "User Management",
        "add": "Add User",
        "edit": "Edit User",
                "name": "User Name",
        "inputName":"Please enter the User name",
        "organization": "Organization",
        "role": "Role",
        "creator":"Creator",
        "createTime":"Creation time",
        "state":"State",
        "actions":"Actions",
        "noData":"No data",
        "loadListFailed":"Load list failed",
        "createdAt":"Created At",        
        "changePassword":"ChangePwd",        
        "oldPassword":"Original password",
        "newPassword":"New password",
        "password":"password",
        "confirmPassword":"Confirm password",
        "inputPassword":"Please enter the password",
        "inputConfirmPassword":"please enter your confirmation password",
        "associatRole":"Associated role",
        "associatOrganization":"organization",
        "selectCompany":"Please select an organization",
        "selectRole":"Please select a role",
        "nameRequired":"Please enter the name",
        "passwordRequired":"Please enter the password",
        "oldPasswordRequired":"Please enter original password",
        "confirmPasswordRequired":"Please enter your confirmation password",
        "companyRequired":"Please select an organization",
        "roleRequired":"Please select a role",
        "inputOldPassword":"Please enter original password",
        "inputNewPassword":"Please enter new password",
        "addSuccess":"Add success",      
        "addFailed":"Addition failed, please check the input information",
        "passwordNotMatch":"The two passwords are different, please re-enter",
        "passwordNull":"Password cannot be empty",        
        "passwordMinLength": "The password length cannot be less than 6 characters",
        "operationFailed":"Data exception, please check the data",
        "updateSuccess":"Update success",
           "updateFailed":"Update failed",     
           "deleteSuccess":"Delete success",       
           "deleteFailed":"Delete failed",         
           "deleteConfirm": "Confirm to delete user \"{name}\"?",
           "DisableConfirm": "Confirm to disable user \"{name}\"?",
           "langType":"Lang Type",
           "langTypeRequired":"Please select a language",
           "editLang": "Edit Language",
      "langUpdateSuccess": "Language updated successfully",
      "langUpdateFailed": "Failed to update language"
          
    },
    user: {
      guest: 'Guest',
      profile: 'Profile',
      logout: 'Logout'
    },
    "role":{
       "title": "Role Management",
      "add": "Add",
      "edit": "Edit",
      "id": "Role ID",
      "name": "Role Name",
      "nameEn": "English Name",
      "description": "Description",
      "userCount": "User Count",
      "actions": "Actions",
      "menuConfig": "Menu Config",
      "inputName": "Please enter role name",
      "inputNameEn": "Please enter English name",
      "inputDescription": "Please enter description",
      "nameRequired": "Please enter role name",
      "nameLength": "Role name must be 2-30 characters",
      "nameEnLength": "English name cannot exceed 60 characters",
      "descriptionLength": "Description cannot exceed 100 characters",
      "loadFailed": "Failed to load role list",
      "addSuccess": "Role added successfully",
      "editSuccess": "Role edited successfully",
      "updateSuccess": "Role updated successfully",
      "deleteSuccess": "Role deleted successfully",
      "addFailed": "Failed to add role",
      "updateFailed": "Failed to update role",
      "deleteFailed": "Failed to delete role",
      "submitFailed": "Failed to submit form",
      "deleteConfirm": "Are you sure to delete role \"{name}\"?",
      "loadMenuFailed": "Failed to load menu data",
      "menuConfigSuccess": "Menu config saved successfully",
      "menuConfigFailed": "Failed to save menu config",
      "save": "Save"
    },
    "operationLog":
    {
      "company":"Organization",
      "selectCompany": 'Please select organization',
        "inputName":"Please enter the operator",
        "loadListFailed":"Loading list failed",
      "title":"Operation Log",
      "inputContents":"Please enter the operation content",
          "id":"id",      
          "companyName":"Organization",
      "name":"Operator",
      "contents":"Operation content",
      "result":"Result",
      "createdAt":"Operation time",
            "timeRange":"Time range",      
      "startTime":"Start time",
        "endTime":"End time",
    },
    gateway: {
      title: 'Gateway Management',
      add: 'Add Gateway',
      edit: 'Edit',
      delete: 'Delete',
      company: 'Organization',
      name: 'Gateway Name',
      status: 'Status',
      imei: 'IMEI',
      sn: 'SN Code',
      manufacturer: 'Manufacturer',
      protocol: 'Protocol',
      createTime: 'Create Time',
      actions: 'Actions',
      all: 'All',
      offline: 'Offline',
      online: 'Online',
      search: 'Search',
      reset: 'Reset',
      selectCompany: 'Select Organization',
      inputName: 'Input Gateway Name',
      selectStatus: 'Select Status',
      nameRequired: 'Please input gateway name',
      companyRequired: 'Please select organization',
      imeiRequired: 'Please input IMEI',
      snRequired: 'Please input SN code',
      manufacturerRequired: 'Please select manufacturer',
      protocolRequired: 'Please select protocol',
      description: 'Description',
      inputDescription: 'Input description',
      selectManufacturer: 'Select manufacturer',
      selectProtocol: 'Select protocol',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addTitle: 'Add Gateway',
      editTitle: 'Edit Gateway',
      deleteConfirm: 'Confirm to delete this gateway?',
      tip: 'Tip',
      deleteSuccess: 'Delete success',
      deleteFailed: 'Delete failed',
      deleteCancelled: 'Delete cancelled',
      updateSuccess: 'Update success',
      addSuccess: 'Add success',
      addFailed: 'Add failed',
      loadDataFailed: 'Failed to load data',
      loadCompanyFailed: 'Failed to load organization data',
      manufacturer1: 'YouRen-M300',
      manufacturer2: 'LanFeng-LF220',
      manufacturer3: 'usr-Else'
    },
    template:
    {
      title: 'Template Management',
      add: 'Add Template',
      edit: 'Edit',
      delete: 'Delete',
      company: 'Organization',
      search: 'Search',
      reset: 'Reset',
      selectCompany: 'Select Organization',
      inputName: 'Input Template Name',
      id:"id",
      name:"Template Name",      
      getType: "Acquisition methods",
      getTypeA: "Cloud polling",
      getTypeB: "Edge acquisition",
      varTotal: "Total number of variables",
      deviceTotal:"Number of associated devices",
      stateType: "State Configuration",
      stateTypeA: "Gateway",
      stateTypeB: "Device data",
      createTime: "Create Time",
      subUser: "Sub User",
      slaveConfig: "Slave Config",
      variableConfig:"Variable Config",
      actions: "Actions",
      cancel: "Cancel",
      confirm: 'Confirm',      
      addTitle: 'Add Template',
      editTitle: 'Edit Template',
      deleteConfirm: 'Confirm to delete this device template?',
      fetchError: "Fetch Error",
      deleteSuccess: 'Template Delete success',
      deleteFailed: 'Template Delete failed',      
      deleteCancelled: 'Delete cancelled',
      updateSuccess: 'Template Update success',
      addSuccess: 'Template Add success',
      submitError: "Submit Error",
      nameRequired: 'Please input template name',
      companyRequired: 'Please select organization',
      getTypeRequired: 'Please input Acquisition methods',
                 save:"Save Template",
           saveFailed:"Template save failed,Please check if there are any duplicate names",
           saveSuccess: "Template Save Success",
           updateFailed:"Template update failed,Please check if there are any duplicate names",
            validate:   "Please enter the correct template data",
            noDataReturned: "No data returned",
            selectCompanyFirst:"Select organization first",
              
    },
    slave:
    {
        tabName:"Slave Name",
        protocol:"Protocol",
        addVariable:"Add",
        searchByName: "Variable Name",
        VariabledataType:"Variable Data Type",
        queryVariable:"Query",
        importVariables:"Import",
        exportVariables:"Export",
        importUpdateVariables:"Modify",
        importUpdateSuccess:"Update Success",
        importUpdateTip:"import Update Tip",
        batchDelete:"Batch Delete",
        keepOneTab:"keep One Tab",
        completeCurrentTab:"Complete Current Tab",
        addSlave:"Add Slave",
        confirmDeleteTab:"Confirm Delete Tab",        
        varName:"Comm name",
        display_name:"DisplayName",
       variableInputDisplayName:"Please enter the variable display name", 
        description:"Description",
          inputDescription:"Please enter variable description",
           name_group:"Group",
           groupSort:"GroupSort",
           groupName:"groupName",
           groupSortTip:"groupSortTip",
           groupSorts:"groupSorts",
             inputGroupName:"please input group name",
       varType:"Variable Type",
       valueType:"Value Type",
         rwType:"Write&Read",
     storageMode:"Storage Mode",
     actions: "Actions",
     register:"Register",
     completeRequiredFields:"Complete Required Slave Fields",
    updateSuccess:"Slave Update Success",
    createSuccess: "Slave Add Success",
    createFail: "Slave Add Fail,Please check if there are any duplicate names",
    updateFail:"Slave Update Fail,Please check if there are any duplicate names",      
    deleteSuccess: 'Slave Delete success',
    deleteFailed: 'Deletion of slave failed. The device has already been bound. Please unbind it first',
    editVariable: "Edit Variable",
    basicInformation:"Basic information",
      descriptionInformation:"Description information",
   registerConfig:"Register Config",
    dataTypeConfig:"Data Type Config",
    dataValueConfig: "Data Value Config",
      registerType: "RegType",
      addressOne: "RegAddr",
      addressTwo: "Address 2",
      addressThree: "Address 3",
      addressFour: "Address 4",
      addressFive: "Address 5",
      addressSix: "Address 6",
      addressDecimal: "Decimal",
      registerNum: "RegisterNum",
      timedStorageFreq: "Timed Storage Frequency",
      changeStorageVal: "Change Storage Value",
      varFlag: "Variable Flag",
      unit: "Unit",       
      value:"default value",
       mult:"Multiplication",
    minimum: "Minimum",
    maximum:"Maximum", 
      variableSaved: "Variable Saved",
      variableSaveFailed:"Variable save failed, please check for duplicate names",
    variableUpdateFailed:"Variable Update Failed",
        variableDeleted:"Variable Deleted",      
      variableDeleteFailed:"Variable Delete Failed",
      variableInputName: 'Input the variable communication name',  
       dragFileHere: "Drag the file here", 
      clickToUpload: "click upload",
      supportedFileTypes: "Supported file types",
      selectFileFirst: "Please select the file first",
      tabNotFound: "Slave Tab not found",
      importSuccess: "Import was successful",
      importing: "importing",
      importFailed: "Import failed",
      exportSuccess: "Export was successful",
      exportFailed: "Export failed",
      exportError: "Export error",
      exportDataError: "The response is not valid file data",
      confirmDeleteVariables:"Confirm Delete Variables",
      interval:"Interval",
      variableTypeA: "Directly collected variable",
      variableTypeB: "Operational variable",
      variableTypeC: "Input variable", 
      rwTypeRW: "RW",
       rwTypeR: "R",
       rwTypeW: "W",
        storageModeOptionA: "All Storage",
      storageModeOptionB: "Change Storage",
      variableUpdateSuccess: "Variable Update Success",
          "batchUpdateGroupSort":"batchUpdateGroupSort",
          "groupSortUpdateSuccess":"groupSortUpdateSuccess",
          "groupSortUpdateFailed":"groupSortUpdateFailed",
          "groupSortConfig":"groupSortConfig",
    },
    clientProject:{
      "monitor":"Monitor",  
      "title":"Project List",
      "search":"Search",
      "reset":"Reset",
      "add"   :"Add",
      "edit"  :"Edit",
      "id":"Id",
      "name": "Project name",
      "company":"Organization",
      "state":"State",
      "location":"Location",
      "description":"Description",
      "createTime":"Create time",
      "actions":"Actions",
      "inputName":"Please enter the project name",
           "online"  : "Partially Online",
        "Allonline"  : "Online",
        "offline" :"Offline",
           "deleteSuccess": 'Delete success',
    "deleteFailed": 'Delete failed',
 "deleteCancelled": 'Delete cancelled',
    "deleteConfirm": "Are you sure to delete the project \"{name}\"?",
    "addProjectTitle":"Add project monitoring information",
    "editProjectTitle":"Edit project monitoring information",
     "RealTimeMonitor":"Real time Monitor & Control",
     "switchedToMode": "Switched to {mode} group",
    },
    "ClientProjectMonitor":
    {
        "SystemMonitoring":"System Monitoring",         
      systemSettings: "System Settings",
      systemDebug: "System Debug", 
      energyAnalysis: "Energy Analysis",
      historyReports: "History Reports",
      eventManagement: "Event Management",
      psp: "PSP",
      outdoorLargeIceMachine: "Outdoor Large Ice Machine",
      outdoorSmallIceMachine: "Outdoor Small Ice Machine",
      indoorLargeIceMachine: "Indoor Large Ice Machine", 
      indoorSmallIceMachine: "Indoor Small Ice Machine",
      enterFullscreen: "Full Screen",
      exitFullscreen: "Exit Full Screen",
      enteredFullscreen: "Entered full screen mode",
      exitedFullscreen: "Exited full screen mode", 
      fullscreenFailed: "Full screen request failed",
      switchedToMode: "Switched to {mode} mode",
      switchedToPage: "Switched to {page}",
      unknown: "Unknown",
      unknownPage: "Unknown Page",
            noBusinessData: "No business data found",
      loadBusinessSuccess: "Successfully loaded {count} business options", 
      loadBusinessFailed: "Failed to load business options"
    },
    "ClientProjectMonitorSystemMonitoring":
    {
        "configuration":"Graph",
        "operation":"Operation",
        "alarm":"FDD",
             "setup":"Setup",
               "advanced":"Advanced",
                 "noData":"No data",
             "loadFailed":"Load failed",
    },
    "ClientProjectMonitorSystemMonitorParmater":
    {
      "loadFail":"Data loading failed",
      "queryAllData":"All Data",
       "queryData":"Query Data",        
             "track": "Refresh Settings",
            "stopTrack":"Stop Updates",
        "connectError":"Connection Error",
        "noVariables":"No available data",
        "noDevices":"No Devices",
        "rollCallConfirm":"Confirm Refresh",
        "rollCallTitle":"Update all data on the current page",
        "rollCallSuccess":"Refresh Successful",
        "rollCallError":"Refresh Failed",        
          "currentValue":"Current Value",
            "parmCount":"Parameters",  
            "historyData":"Timeseries Plot",
            "RealTimePlot":"Real-time Plot",
            "XYPlot":"X-Y Plot",
               "paginationSelect":"Please select",
                       "paginationAll":"All",
                      "paginationPage":"Items/Page",
                    "showAllData": "All {count} data has been displayed",    
            "selectVariableFirst": 'Please select variables in the data blocks first',
      "maxFiveVariables": 'A query cannot exceed 10 variables at a time',
      "historyDataTitle": 'Timeseries Plot - {count} variables',
      "X-YDataTitle": 'X-Y Plot - {count} variables',
      "realTimePlotTitle": 'Real-time Plot - {count} variables',
           "noVariablesConfirm": "You did not select a specific variable, all variables will be updated. Are you sure you want to do this?",
           "confirmTitle": "Confirm action",
           "trackingStarted":"Data update begins",
           "trackingStopped":"Data update stopped",
           "updateAll":"Refresh",
                 "updateMode": "Refresh Mode",
      "autoUpdate": "Auto Refresh",
      "manualUpdate": "Manual Refresh", 
      "updateInterval": "Refresh Interval",
      "oneSecond": "1 Second",
      "fiveSeconds": "5 Seconds", 
      "tenSeconds": "10 Seconds",
      "thirtySeconds": "30 Seconds",
      "noUpdate": "No Refresh",
      "customInterval": "Custom Interval",
      "enterInterval": "Enter interval",
      "seconds": "Seconds",
      "updateInfo": "Refresh Information",
      "autoUpdateDesc": "Update data automatically based on device upload frequency",
      "minutes": "Minutes",
      "durationTips": "Set the total duration for tracking",
      "trackingStatus": "Tracking Status",
      "trackingActive": "Tracking Active",
      "remainingTime": "Remaining Time",
      "currentInterval": "Current Interval",
      "tracking": "Tracking...",
      "invalidInterval": "Please set a valid update interval",
      "setValueError": 'The set value is not within the specified range - minimum {minimum} - maximum {maximum}',
      "invalidNumber":"Invalid number",
       'invalidTime':"Invalid time",
       "splitScreenMonitoring":"splitScreen Plot"
    },
    "ClientDeviceMonitorSystemMonitorSetup":
    {
        "setup":"Update",
        "sendSetup":"Send value",
        "currentValue":"Current value",
        "setupVlaue":"Set value",
        "description":"Description",
    "confirmSetValue": "Are you sure you want to set {title} to {value} {unit}?",
      "confirmSet": "Confirm Setting",
      "setSuccess": "Parameter {title} set successfully",
      "setFailed": "Failed to set parameter {title}: {error}",
      "connectError": "Connection error, please check network connection",
      "noVariables": "No variables available to set",
      "noDevices": "No devices found"
    },
    "ClientDeviceMonitorSystemDebug":
    {
        "hostDebug":"Host Debug",
        "handDebug":"Manual Debug",
    },
    "ClientDeviceMonitorSystemDebugHostDebug":
    {
            "currentValue":"Current Value",
      "setValue":"Set Value",        
        "send":"send",        
              "confirmSetValue": "Are you sure you want to set {title} to {value} {unit}?",
      "confirmSet": "Confirm Setting",
      "setSuccess": "Parameter {title} set successfully",
      "setFailed": "Failed to set parameter {title}: {error}",
      "connectError": "Connection error, please check network connection",
      "noVariables": "No variables available to set",
      "noDevices": "No devices found"
    },
    "ClientDeviceMonitorSystemSettings":
    {
        "alarmReset":"Alarm Reset",
        "executionPlan":"Execution Plan",
        "systemSettings":"System Settings",
    },
    "ClientDeviceMonitorSystemSettingsAlarmReset":
    {
        "reset":"Reset",        
        "confirmRetset":   `Are you sure you want to reset {title}?`,
          "confirmReset": "Confirm Reset",
          "normal" :"Normal",
        "alarm" :"Alarm",
            "locked": "Locked",
    "comm-error": "Comm-error",
        "reSetSuccess": "{title} reset successfully, {count} total",
        "resetFailed": "Failed to reset parameter {title}: {error} reset",
        "errorDeviceCode": "The target variable and the current alarm variable are not on the same device!",
            "noLinkageVars":"No linked variable, variable {name} needs to be reset?",
    },
    device: {
      "title": "Device Management",
      "add": "Add Device",
      "edit": "Edit",
      "view":"view",
      "delete": "Delete",
      "basicInfo": "Basic Information",
      "networkSettings": "Network Settings",
      "dataSettings": "Data Settings",
      "name": "Device Name",
      "code": "Device Code",
      "company": "Organization",
      "selectCompany": "Select Organization",
      "description": "Description",
      "location": "Location",
      "gateway": "Gateway",
      "selectGateway": "Select gateway",
      "template": "Device template",
      "associatedDeviceTemplate": "Associated device template",
      "selectTemplate": "Select template",
      "slaveTotal": "Slave total",
      "varTotal": "Variable total",
      "collectionType": "Collection type",
      "varName": "Variable name",      
      "valueType": "Value type",
      "slave": "Slave",
      "state": "Status",
      "offline": 'Offline',
      "online": 'Online',
      "createTime": "Create time",
      "actions": "Actions",
      "search": "Search",
      "reset": "Reset",
      "inputName": "Please input device name",
      "nameRequired": "Device name is required",
      "codeRequired": "Device code is required",
      "companyRequired": "Organization is required",
      "gatewayRequired": "Gateway is required",
      "selectTemplateFirst": "Please select a template first",
      "selectCompanyFirst": "Please select organization first",
      "addTitle": "Add Device",
      "editTitle": "Edit Device",
      "deleteConfirm": "Confirm to delete device {name}?",
      "deleteSuccess": "Device deleted successfully",
      "deleteFailed": "Device delete failed",
      "addSuccess": "Device added successfully",
      "updateSuccess": "Device updated successfully",
      "submitError": "Device submit failed",
      "loadCompanyFailed": "Failed to load organization list",
      "loadGatewaysFailed": "Failed to load gateway list",
      "loadTemplatesFailed": "Failed to load template list",
      "loadTemplateFailed": "Failed to load template details",
      "loadTemplateVarFailed": "Failed to load template var details",      
      "cancel": "Cancel",
      "save": "Save",
      "confirm": "Confirm",
      "slaveName": "Slave name",
      "serialPort":  "Serial Port",
      "slaveAddress": "Slave Address",
      "inputSerialPort": "Input serial port",        
      "inputSlaveAddress": "Input slave address",
      "serialSerialNumber": "Serial serial number",  
      "serialPortMustBeNumber": "Serial port must be number",
  "slaveAddressMustBeNumber": "Slave address must be number",  
      "slaveConfig": "Slave config"
    },
    reaTimePlot:{
      "deviceVariableMonitor":"Curve trend chart",
            "ScatterTrendChart":"Scatter Trend Chart",
      "selectDevice":"Select device",
      "companyDeviceTree":"Company device tree",
      "monitorVariable":"Monitor variable",
      "selectVariable":"Select variable",
      "loadDeviceTreeFailed":"Failed to load device tree",
        "loadVariableListFailed":"Failed to load variable list",
              "VariableListNoData":"Variable list no data",
                    "SelectVarMax":"The selection of variables should not exceed 10",
                    "dataProcessError":"Data process error",
                    "MonitoringDuration": "Monitoring duration(Hour)",
                    "minute": "Minute",
                    "hour": "Hour",
                    "time": "Time",
            "leaveConfirm": "Monitoring data, are you sure you want to leave?",
  "releasingSubscription": "Releasing data subscription, please wait...",
             "leaveError": "An error occurred while leaving the page",
          "releaseFailed": "Failed to release subscription",
               "rollCall": "Begin Capture",
                  "track": "Refresh settings",
                  "stopTrack":"Stop Updates",
                  "trackingStopped":"Update stopped",
                "interval":"Interval (seconds)",
                "duration":"Duration (minutes)",
                "trackingCompleted": "Update completed",
                "trackingStarted": "The update has started",      
               "connectError": "Connect error",
               "reconnecting": "Attempting to reconnect ({attempts}, retry in {seconds} seconds) ...",               
               "notEnoughMemory": "Your device has low memory({memorys}GB), which may affect data processing performance",
               "exceed": "The time range cannot exceed ({val} hours)",
               "exceedDay": "The time range cannot exceed ({val} days)",
           "stopReceiving":"stopReceiving",
          "startReceiving":"startReceiving",
                "receiving":"receiving",
                  "paused":"paused",
                  "dataReceivingPaused":"dataReceivingPaused",
                  "dataReceivingResumed":"dataReceivingResumed",        
                        "stopDataFirst":"stopDataFirst"
    },
    realTimeData:{      
           "selectDevice":"Select device",
      "companyDeviceTree":"Company device tree",
      "slaveList":"Slave list",
      "selectVariable":"Query variable",
      "loadDeviceTreeFailed":"Failed to load device tree",
        "loadVariableListFailed":"Failed to load variable list",
       "VariableListNoData":"Variable list no data",  
    "dataProcessError":"Data process error",                 
      "leaveError": "An error occurred while leaving the page",
          "releaseFailed": "Failed to release subscription",               
      "rollCall": "Poll",
               "connectError": "Connect error",
      "reconnecting": "Attempting to reconnect ({attempts}, retry in {seconds} seconds) ...",
      "time" : "time",
      "deviceName": "Device Name",
      "varname": "Comm name",
      "display_name": "Variable name",
     "name_group": "Variable group",
      "Variable_description": "Description",
      "SlaveName":"SlaveName",
      "varType":"Variable Type",
            "updateTime": "Update Time",
            "currentValue": "Current Value",
            "unit": "Unit",
            "setValue": "Set Value",      
            "actions": "Actions",
            "query": "Query",
            "activeCollection": "Active Collection",
            "edit":"Edit",
            "valuePlaceholder":"Please enter the setting value",
            "inputVarName":"Please enter the variable name",
            "inputGroupName":"Please enter the variable group name",            
            "selectVariableGroup":"Select variable grouping (multiple choices allowed)",      
            "allGroups":"All groups",
       "selectedGroups": "{count} groups have been selected",                   
            "editDialogTitle":"Edit",
            "hostOrganization":"Host organization:",
      "deviceTemplate":"Device template:",
      "gateway":"Device gateway:",
      "deviceAddress":"Device address:",
      "deviceTags":"Device tags:",
      "deviceDescribe":"Device description:",
                  "columnSettings": "Column settings",
      "selectColumns": "Select columns",
      "columnSettingsSaved": "Column settings saved",
      "showPagination":"pagination",
                  "loadingMore": "Loading...",
            "noMoreData": "No more data",
            "noData": "No data available",
            "loadMoreError": "Failed to load more data",
                  "lockScroll": 'Lock Scroll',
    "unlockScroll": 'Unlock scroll',
    "scrollLocked": 'Scroll locked',
    "scrollUnlocked": 'Scroll unlocked',
    "scrollLockedAlert": 'The scrolling function is locked and will not automatically load new data',
    "scrollLockedMessage": 'Scroll locked',
        "deviceInfo": "Device information",
      "expand":"Expand",
      "collapse":"Collapse",
      "selectDeviceOnly":"Only devices can be selected",
    },
    "historyRecord":
    {
      "points": " pts",
      "selectXAxisVariableFirst": "Please select X-axis variable first",
        "xAxisVarNotFound": "Device configuration for X-axis variable {name} not found",
      "queryDataSuccess": "Queried {count} historical data records, total {days} days",
        "noValidXAxisData": "No valid X-axis data found",
      "query":"Refresh",      
        "reset":"Reset",
        "selectTimeRange":"Please select time range",
        "queryFailed":"Query failed",
        "queryError":"Query error",
            "loadMore":"Load more",
            "noMoreData":"No more data",
            "processError":"Process error",
            "queryCompleted":"Query completed",
      "timeRange":"Time range",
         "today" : "today",
         "yesterday":"yesterday", 
         "sevenDays":"7 days",
         "24hour" : "24Hour",
         "startTime":"Start time",
         "quickTime":"Query time",
        "endTime":"End time",
      "selectTime": "Select time",
      "exportVariables":"Data Download",
      "exportSuccess": "Download successful",
      "exportFailed": "Download failed",
      "exportError": "Download error",
      "exportDataError": "The response is not valid file data", 
            "noData":"No data",
            "selectVariables":"Please select variables",
            "aggregateData":"Data aggregated: {total} items",
            "timeTip":"Failed to query 24-hour device time, use current computer time to query",
              "yAxisControl":"X-Y Axis Range Control",
              "showAllXAxisSettings": "Show X Axis Settings",
      "showAllYAxisSettings":"Show All Y Axis Settings",
      "clearAllYAxisRanges":"Clear All Y Axis Ranges",
      "clearAllXAxisRanges": "Clear X Axis Ranges",
      "yAxisRangeManagement":"Y Axis Range Management",
      "xAxisRangeManagement": "X Axis Range Management",
      "setYAxisRange":"Set {name} Y Axis Range",
        "setXAxisRange": "Set X Axis Range",
        "xResetAuto": "Reset",
      "minValue":"Min Value",
      "maxValue":"Max Value",
      "xAxisPointCount":"X-axis:",
      "invalidRange":"Please enter a valid numeric range",
      "minGreaterThanMax":"Min value cannot be greater than or equal to max value",
      "rangeSetSuccess":"Y axis range set successfully",
      "rangeXSetSuccess": "X axis range set successfully",
      "rangeXResetSuccess": "X axis range reset successfully",
      "rangeResetSuccess":"Y axis range reset successfully",
      "allRangesCleared":"All Y axis ranges cleared",
      "XRangesCleared": "X axis ranges cleared",
      "manual":"Manual",
      "auto":"Auto",      
      "cancel":"Cancel",
      "confirm":"Confirm",
      "timeMode":"Time Mode",
        "variableMode":"Variable Mode",
        "selectXAxisVariable":"Select X-axis variable",
            "startTimer": "Start Timer",
              "endTimer": "End Timer",
                       "placeholderStartTimer": "Please select a start time",
          "placeholderEndTimer": "Please select an end time",      
       "xAxisRangeSetSuccess": "X-axis range has been set to {min} to {max}",
            "selectValidTimeRange": "Please select a valid time range",
      "startTimeLessThanEndTime": "Start time must be less than end time",
            "multiTimeRange": "Multiple Time Ranges",
      "multiTimeRangeManagement": "Multi Time Range Management",
      "multiTimeRangeTip": "Multiple time intervals can be added, and the data will be merged and displayed on the chart",
      "multiTimeRangeSet": "{count} time periods have been set",
      "noValidTimeRange": "No valid time range",
      "timeRangeSections":"Time Range Sections",
      "addTimeSection":"Add Time Section",
      "section":"Section",
      "queryDataSuccessMulti":"Total query data: {count} entries, {sections} segments, {hours} hours",
      "delete":"delete",
      "sectionDeleted":"Section deleted",
      "sectionAdded":"Section added",
            "controlNo":"Multi-time period, X-axis uncontrolled",
            "xAxisPaddingControl":"xAxis padding control",
 "leftPadding":"leftPadding",
"rightPadding":"rightPadding",
"resetPadding":"Reset",
"paddingTip":"Control images through left and right margin settings",
"sectionGap": "SectionGap",
    "stopDataFirst":"stopDataFirst",
     oneYear: 'One Year',
    trendCalc: 'Trend Calc',
    trendOn: 'Trend',
    trendOff: 'Raw',
    maxPoints: 'Max Points',
    autoPoints: 'Auto',
    aggregateStep: 'Aggregate Step',
    stepRaw: 'Raw Data',
    step1min: '1 Minute',
    step5min: '5 Minutes',
    step10min: '10 Minutes',
    step20min: '20 Minutes',
    step1h: '1 Hour',
    step1d: '1 Day',
    aggregateType: 'Aggregate Type',
    aggAvg: 'Average',
    aggMax: 'Maximum',
    aggMin: 'Minimum',
    aggFirst: 'First',
    aggLast: 'Last',
    autoLoadOnZoom: 'Auto Load on Zoom',
    on: 'On',
    off: 'Off',
    enlarge: 'Enlarge',
    exitEnlarge: 'Exit Enlarge',
    "fullDayMode":"fullDayMode",
"tooManyVariablesForLongRange": 'When the query range exceeds {days} days, at most {max} variables can be selected',
"longRangeVarLimitTip": 'At most 3 variables when the range exceeds 30 days'
    },
    CompDeviceTree:{
      "searchDevice":"Search device",
    },
      varableSelectorControl:{     
    "pleaseSelect": "Please select",
    "totalCount": "Total {total} items",
    "slaveList": "Slave List",
    "inputSlaveName": "Input slave name",
    "allSlaves": "All Slaves",    
    "variableList": "Variable List",
    "searchVariable": "Search variable",  
      "selectDeviceFirst": "Please select device first",
      "selectVariableFirst": "Please select variable first",      
      "noVariableData": "No variable data",    
      "loadSlaveFailed": "Failed to load slave list",
      "loadVariableFailed": "Failed to load variable list",
      "selectAll":"SelectAll",
      "unselectAll":"UnselectAll",     
      "loadGroupFailed":"Load group failed" 
    },
    "ClientProjectDeailAdd": {
    // 项目信息配置相关
    "projectInfoConfig": "Project Information Configuration",
    "projectName": "Project Name",
    "enterProjectName": "Please enter project name",
    "projectOptions": "Project Options",
    "selectBusiness": "Please select business",
    "projectDescription": "Project Description",
    "projectSort":"project Sort",
    "enterProjectDescription": "Please enter project description",
    "projectLocation": "Project Location",
    "enterProjectLocation": "Please enter project location",
    
    // 参数模块相关
    "parameterModule": "Parameter Module",
    "parameterOptions": "Parameter Options",
    "selectParameterOptions": "Please select parameter option",
    "parameterModuleName": "Parameter Module Name",
    
    // 变量相关
    "id" :"id",
    "deviceId": "Device Id",
    "variableName": "Variable Name",
    "deviceName": "Device Name",
    "displayName": "Display Name",
    "variableValue": "Variable Value",
    "unit": "Unit",
    "sort":"sort",
    "operations": "Operations",
    "addVariable": "Add Variable",
    "importVariables": "Import Variables",
    "refreshVariables": "Refresh Variables",
    "queryingVariables": "Querying variables...",
    "refreshVariableList": "Refresh variable list",
    "exportVariables": "Export Variables",
    "batchDelete": "Batch Delete",
    "search": "Search",
    "save": "Save",
    "variableGroup": "Variable Group",
    "variableDetails": "Variable Details",
    "variableType": "Variable Type",
    "readWriteType": "Read/Write Type",
    "defaultValue": "Default Value",
    "coefficient": "Coefficient",
    "valueRange": "Value Range",
    "decimalPlaces": "Decimal Places",
    "description": "Description",
    "noDescription": "No Description",
    "viewDetails": "View Details",
    "removeFromSelection": "Remove from selection",
    "addToSelection": "Add to selection",
    "searchPlaceholder": "Search variable name, display name or description",
    "selectVariableGroup": "Please select variable group",
    "enterVariableName": "Please enter variable name",
    "enterDisplayName": "Please enter display name",    

      "unnamedVariable": "Unnamed Variable",
      "removeLinkageVariable": "Remove Linkage Variable",
      "addToLinkage": "Add to Linkage",
      "variableAlreadyInLinkage": "Variable is already in linkage list",
      "variableAddedToLinkage": "Variable added to linkage list",
      "confirmRemoveLinkageVariable": "Are you sure you want to remove this linkage variable?",
      "linkageVariableRemoved": "Linkage variable removed",
      "linkageVariableRemovedFailed": "Failed to remove linkage variable",
      "selectLinkageVariables": "Please select linkage variables first",
      "linkageSavedSuccess": "Linkage rules saved successfully",
      "linkagePartialFailed": "Some linkage rules failed to save",
            "removeLinkagedVariable": "There is a binding. Please delete the binding variable first",

    // 对话框相关
    "prompt": "Prompt",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "editVariable": "Edit Variable",
    "addLinkageRule": "Add Linkage Rule",
    "editLinkageRule": "Edit Linkage Rule",
    "close": "Close",
    
    // 联动规则相关
    "linkageType": "Linkage Type",
    "fixedValueDispatch": "Fixed Value Dispatch",
    "multiVariableLinkage": "Multi-variable Linkage",
    "formulaCalculation": "Formula Calculation",
    "triggerCondition": "Trigger Condition",
    "executeImmediately": "Execute Immediately",
    "delayedExecution": "Delayed Execution",
    "executeWhenConditionMet": "Execute When Condition Met",
    "targetVariableId": "Target Variable ID",
    "delayTime": "Delay Time (seconds)",
    "triggerConditionExpression": "Trigger Condition Expression",
    "expressionExample": "e.g.: var1 > 100 && var2 < 50",
    "linkageContent": "Linkage Content",
    "contentExample": "e.g.: 100",
    "linkageFormula": "Linkage Formula",
    "formulaExample": "e.g.: var1 * 2 + var2",
    "ruleDescription": "Rule Description",
    "enterRuleDescription": "Please enter rule description",
    
    // 企业设备树相关
    "companyDeviceTree": "Company Device Tree",
    "selectDevice": "Select Device",
    "slaveList": "Slave List",
    "selectSlave": "Select Slave",
    "allSlaves": "All Slaves",
    "allGroups": "All Groups",
    "enterVariableNamePlaceholder": "Please enter variable name",
    
    // 表格相关
    "belongingDevice": "Belonging Device",
    
    // 成功消息
    "projectSavedSuccess": "Project saved successfully",
    "projectUpdatedSuccess": "Project updated successfully",
    "parameterModuleSavedSuccess": "Parameter module saved successfully",
    "parameterModuleUpdatedSuccess": "Parameter module updated successfully",
    "currentModuleSaved": "Current parameter module has been saved",
    "parameterModuleAddedSuccess": "Parameter module added successfully",
    "savedSuccess": "Saved successfully",
    "variableDeletedSuccess": "Variable deleted successfully",
    "deletedSuccess": "Deleted successfully",
    "successfullyDeleted": "Successfully deleted",
    "querySuccessfulFound": "Query successful, found",
    "variables": "variables",
    "successfullyBatchBound": "Successfully batch bound",
    "variablesToProject": "variables to project",
    "updatedSuccess": "Updated successfully",
    "addedSuccess": "Added successfully",
    
    // 警告消息
    "completeAllModules": "Please complete all parameter module configurations",
    "completeCurrentModule": "Please complete current parameter module configuration",
    "keepAtLeastOneModule": "Keep at least one parameter module",
    "selectModuleFirst": "Please select a parameter module first",
    "saveModuleFirst": "Please save the parameter module first",
    "saveProjectFirst": "Please save the project first",
    "noMatchingVariables": "No matching variables found",
    "selectDeviceFirst": "Please select a device first",
    "selectVariablesFirst": "Please select variables first",
    "allVariablesExist": "All selected variables already exist in the project",
    "noValidVariables": "No valid variables to process",
    "allDeletionsFailed": "All delete operations failed",
    "fillProjectName": "Please fill in project name",
       "fillProjectCompanyId": "Please select an organization",
    "fillModuleName": "Please fill in parameter module name",
    "checkFormData": "Please check form data",
    
    // 错误消息
    "batchDeleteFailed": "Batch delete failed",
    "errorDuringDeletion": "Error occurred during deletion",
    "moduleUpdateFailed": "Parameter module update failed",
    "moduleSaveFailed": "Parameter module save failed",
    "moduleDeleteFailed": "Parameter module delete failed",
    "addFailed": "Add failed",
    "saveFailed": "Save failed",
    "importFailed": "Import failed",
    "exportNotImplemented": "Export variable function to be implemented",
    "errorSavingProject": "Error saving project",
    "errorSavingModule": "Error saving parameter module",
    "deleteFailed": "Delete failed",
    "deleteApiFailed": "Failed to call delete API",
    "batchBindingFailed": "Batch binding failed",
    "errorDuringBatchBinding": "Error occurred during batch binding",
    "queryVariablesFailed": "Failed to query variables",
    "queryFailed": "Query failed",
    "loadSlavesFailed": "Failed to load slaves",
    "loadGroupsFailed": "Failed to load variable groups",
    "loadDeviceTreeFailed": "Failed to load device tree",
    "loadBusinessFailed": "Failed to load business options",
    
    // 确认对话框消息
    "confirmDeleteModule": "Are you sure to delete this parameter module?",
    "confirmDeleteVariable": "Are you sure to delete this variable?",
    "confirmDeleteSelected": "Are you sure to delete selected",
    "confirmDeleteVariables": "variables?",
    "device": "Device",
    "variableDeletionFailed": "variable deletion failed",
    "unknownError": "Unknown error",
    "apiCallException": "API call exception",
    
    // 状态和操作文本
    "selected": "Selected",
    "currentPageSelection": "Current page selection",
    "deviceVariablesFailed": "device variables deletion failed",
    "deleted": "Deleted",
    "success": "Success",
    "failed": "Failed",
    "variableUniqueIdentifier": "Variable unique identifier",
    "removedVariable": "Removed variable",
    "addedVariable": "Added variable",
    "addedToSelectionList": "Added to selection list",
    "clearAllSelections": "Clear all selections",
    
    // 业务类型和参数选项
    "operatingParameters": "Operating Parameters",
    "alarms": "Alarms",
    "systemSettings": "System Settings",
    
    // 功能块相关
    "submitProject": "Submit Project",
    "reset": "Reset",
    "previewConfig": "Preview Configuration",
    "functionBlock": "Function Block",
    "configPreviewConsole": "Configuration preview output to console",
    "moduleCount": "Parameter Module Count",
    "functionBlockCount": "Function Block Count",
    "variableBindingCount": "Variable Binding Count",
    "linkageRuleCount": "Linkage Rule Count",
    
    // 特殊文本
    "placeholder": "--",
    "none": "None",
    "ungrouped": "Ungrouped",
    "unknownParameter": "Unknown parameter",
    "basicInfo": "Basic Information",
    "valueConfig": "Value Configuration",
    "processVariableDataFailed": "Failed to process variable data",
    "noVariablesToBind": "No variables to bind",
    "variablesExist": "variables already exist",
    "variablesInfo": "variables information",
    "notSelected": "Not selected",
    "configPreview": "Configuration preview",
    "validationFailed": "Validation failed",
    "formValidationFailed": "Form validation failed",
    "boundVariable":"Bound variable",
    "noBoundVariable":"No bound variable",
    "searchVariable":"Search variable",
    "searchVariablePlaceholder":"Please enter the variable name",
    "variableList":"Variable list",
     "cannotMoveUp": "Already at the top, cannot move up",
      "cannotMoveDown": "Already at the bottom, cannot move down",
      "moveUpSuccess": "Move up successfully",
      "moveUpFailed": "Failed to move up",
      "moveDownSuccess": "Move down successfully",
      "moveDownFailed": "Failed to move down",
      "sortUpdateSuccess": "Sort order updated successfully",
      "sortUpdateFailed": "Failed to update sort order",
      "sortMinValue": "Sort value cannot be less than 1",
      "sortMaxValue": "Sort value cannot be greater than 9999",
      "sortConflict": "Sort value conflicts with other variables",
      "batchSortUpdateSuccess": "Batch sort update successful",
      "batchSortUpdateFailed": "Batch sort update failed",
      "noSortChanges": "No sort changes to update",
      "reorderSort": "Reorder Sort",
      "exportCurrentPage":"Export current page",
      "importSort":"Import sort order",
      "noDataToExport": "No data to export",
      "exportSuccess": "Export successful",
      "exportFailed": "Export failed",
      "noDataInFile": "No data in file",
      "noValidSortData": "No valid sort data found",
      "confirmImportSort": "Confirm to import sort data? This will update the sorting of matching variables on the current page.",
      "importCount": "Import count",
      "importSuccess": "Import successful, updated",
            "resetSort": "Reset Sort",
      "noDataToReset": "No data to reset",
      "confirmResetSort": "Confirm to reset all variables' sort to 0?",
      "resetSortSuccess": "Reset sort successfully, reset",
      "resetSortFailed": "Reset sort failed",
      "projectGroup":"projectGroup",
      "selectOrEnterProjectGroup":"selectOrEnterProjectGroup"
  },
   multiWindow: {
    // Toolbar
    selectVarPlaceholder: 'Select a writable variable',
    setupBtn: 'Set',
    loadVarBtn: 'Load Variables',
    projectFallback: 'Multi-Window Monitor',

    // Layout options
    layoutHistory: 'Timeseries Plot',
    layoutRealtime: 'Real-time Plot',
    layoutBoth: 'Timeseries Plot + Real-time Plot',

    // Panel titles
    panelHistory: 'Timeseries Plot',
    panelRealtime: 'Real-time Plot',

    // Setup dialog
    dialogTitle: 'Send Set Command -- {title}({varName})',
    currentValue: 'Current Value',
    setValueLabel: 'Set Value',
    description: 'Description',
    cancel: 'Cancel',
    confirm: 'OK',

    // Messages
    atLeastOnePanel: 'At least one panel must be kept',
    pleaseSelectVar: 'Please select a writable variable first',
    invalidNumber: 'Please enter a valid number',
    valueRange: 'Value must be between {min} ~ {max}',
    confirmSetupTitle: 'Confirm Setup',
    confirmSetupMessage: 'Are you sure to set {title} to {value} {unit}?',
    setupSuccess: 'Successfully set {title}',
    setupFailed: 'Setup failed: {msg}',
    unknownError: 'Unknown error',
    // en
    loadVarDialogTitle: 'Load Variables',
    colTitle: 'Variable Name',
    colVarName: 'Variable Key',
    colDeviceCode: 'Device Code',
    colUnit: 'Unit',
    colWritable: 'Writable',
    yes: 'Yes',
    no: 'No',
    selectedCount: '{count} variable(s) selected',
    loadSuccess: 'Added {added} variable(s) ({skipped} skipped as duplicates)',
    maxVariablesLimit:'The maximum number of variables that can be added is {limit}. Excess options have been ignored',
    maxWindows:"Supports up to 9 windows",
    addWindow:"Add-form",
    clearWindows:"Clear-forms",
    multiForm:"Multi-form",
    grid:"Grid"
  }
    // 其他翻译...
  }
}